<template>
    <page :busy="busy" :tabs="tabs">
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>

<script>
import Page from '../../generic/page/page.vue';

export default {
    name: 'ChannelErrors',
    components: {
        Page,
    },
    computed: {
        tabs() {
            return [
                {
                    title: `NextPax Errors`,
                    route: `/app/administration-channel-errors/nextpax/errors/`,
                    active:
                        this.$route.path ===
                        `/app/administration-channel-errors/nextpax/errors/`,
                },
                {
                    title: `Airbnb Errors`,
                    route: `/app/administration-channel-errors/airbnb/errors/`,
                    active:
                        this.$route.path ===
                        `/app/administration-channel-errors/airbnb/errors/`,
                },
                {
                    title: `PayPal Pending`,
                    route: `/app/administration-channel-errors/paypal/errors/`,
                    active:
                        this.$route.path ===
                        `/app/administration-channel-errors/paypal/errors/`,
                },
            ];
        },
    },
    data() {
        return {
            busy: false,
        };
    },
    methods: {
        handleBusy(busy) {
            this.busy = busy;
        },
    },
};
</script>